<template>
  <div :class="componentClass">
    <label :for="selectLabelId">{{selectLabelText}}</label>
    <select class="form-control" :id="selectLabelId" @change="handlePriorityChange">
      <option 
        :selected="currentValue == null"
        :value="null"
      >
        No priority
      </option>
      <option
        v-for="n in numberPriorities"
        :key="n"
        :value="n"
        :selected="currentValue == n"
      >
        {{ n }}
      </option>
    </select>
  </div>
</template>

<script>
export default {
  name: "priorities-select",
  props: {
    numberPriorities: {
      required: true,
      type: Number,
    },
    selectLabelText: {
      required: true,
      type: String,
    },
    selectLabelId: {
      required: true,
      type: String,
    },
    currentValue: {
      required: false,
      type: Number,
    },
    componentClass: {
      required: true,
      type: String,
    },
    priorityName: {
      required: true,
      type: String,
    }
  },
  methods: {
    handlePriorityChange: function(e) {
      this.$emit('prioritySelected', {value: parseInt(e.target.value), model: this.priorityName});
    }
  }
};
</script>